<template>
  <div id="adminCrmCategoriesPages">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">Contenuti / Impostazioni </li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Categorie Post</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <h1>Categorie Post</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content">
          <div class="tab-pane active" id="tabTable" role="tabpanel" style="margin-top: -8px;">
                  <div class="row align-btns" style="width:85%;">
                    <div class="col-lg-6">
                      <button id="btnAdd" type="button" class="btn btn-primary" @click="onClickNew">
                        <i class="fa fa-plus"></i>
                        <span>{{ add }}</span>
                      </button>
                    </div>
                  <span style="margin-top:8px;">{{ language }}</span>
                    <div class="col-3 text-left">
                      <select2
                        id="select_AdminPagesView_IdLanguage"
                        ref="select_AdminPagesView_IdLanguage"
                        class="form-control nopadding"
                        style="width:75%"
                        :filterable="false"
                        service="languages"
                        v-model="
                        pageValueSelected.languagePageSetting.idLanguage"
                        :default="defaultLanguageOptions"
                        :change="languageChange"
                      />
                   
                    </div>
                  </div>
  
            <div class="card-body" style="padding:0px;">
              <bootstrapTable
                :configurations="TableConfiguration"
                :datas="tableData"
                id="tableContents"
                ref="tableContents"
                :onCheck="onTableCheckCustomer"
                :results="tableCategoriesPagesResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabNationDetail" role="tabpanel">
            <div class="card-body" style="padding:30px;">
              <div class="row">
                <div v-if="rowIdSelected > 0">
                  <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                </div>
                <div v-else>
                  <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                </div>
                <pageDetail
                  functions="AdminSettingCategoriesPages"
                  :configurations="DetailConfiguration"
                  :jsonValue="detailCategoriesPagesData"
                ></pageDetail>
              </div>
              <!-- upload share img -->
              <div class="row" style="margin-top:15px;margin-bottom:15px;">             
                <div class="col-4 align-self-center">
                  <label class="col col-form-label nopadding label-effect" id="col-form-label">Url cover image</label>
                  <button class="btn btn-primary" @click="getImageShare(pageImageShare)">Seleziona</button>
                
                </div>  
                <div class="col-4 align-self-center">
                  <img style="max-width:100%;max-height: 100px;" :src="detailCategoriesPagesData.url_cover_image">
                </div>
                <div class="col-4 align-self-center">
                  <label id="move-file" v-cloak @drop.prevent="handleFileInputShare" @dragover.prevent class="custom-file-upload" style="padding: 50px; width:100%;">
                    <input id="imgAggUpload" type="file" name="file-input" multiple="True" @change="handleFileInputShare" />SFOGLIA/UPLOAD AREA
                  </label>
                </div>
              </div>
             <!-- <div class="row" style="margin-top:15px;margin-bottom:15px;">             
                <div class="col-4 align-self-center">
                    <button class="btn btn-primary" @click="convertToWebP()">Converti in webP</button>
                  </div>
              </div>--->

              <!-- end upload share img --> 
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="cancelNewCategoriesPages"
                  ><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
                  <button type="button" class="btn btn-success" @click="saveNewCategoriesPages"><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal immagini share -->
    <div
      class="modal"
      id="modalImgBlogFormShare"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialo popup" role="document">
        <div class="modal-content modal">
          <div class="modal-header text-center">
          

            <div class="row" style="width:100%;">
              <div class="col-4 text-left"> 
                <h2 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Gestione immagini</h2>
              </div>
              <div class="col-2 text-right">
              <select class="form-control" id="monthShare" name="monthShare" @change="SearchShare()">
                <option value="">Mese</option>
                <option value="01">Gennaio</option>
                <option value="02">Febbraio</option>
                <option value="03">Marzo</option>
                <option value="04">Aprile</option>
                <option value="05">Maggio</option>
                <option value="06">Giugno</option>
                <option value="07">Luglio</option>
                <option value="08">Agosto</option>
                <option value="09">Settembre</option>
                <option value="10">Ottobre</option>
                <option value="11">Novembre</option>
                <option value="12">Dicembre</option>
              </select>
            </div>
            <div class="col-2 text-right">
              <select class="form-control" id="yearShare" name="yearShare" @change="SearchShare()">
                <option value="">Anno</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
                <option value="2021">2021</option>
                <option value="2020">2020</option>
                <option value="2019">2019</option>
                <option value="2018">2018</option>
                <option value="2017">2017</option>
                <option value="2016">2016</option>
                <option value="2015">2015</option>
                <option value="2014">2014</option>
                <option value="2013">2013</option>
                <option value="2012">2012</option>
                <option value="2011">2011</option>
                <option value="2010">2010</option>
              </select>
            </div>
              <div class="col-4"> 
                <input type="text" class="form-control" id="searchShare" required="required" name="searchShare" placeholder="Cerca" @keyup="SearchShare()"/> 
              </div>
            </div>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mx-3">
            <div class="md-form mb-5">
              <div
                class="row">
                <ul class="list-group" id="ul-image-share" @scroll="handleScrollShare">
                <li class="listLi" v-for="resultFilePopup in resultFilePopupsShare" v-bind:key="resultFilePopup.id" @click="
                  selectImgShare(
                  resultFilePopup.img,
                  resultFilePopup.imgName)" >
                  <div class="list-group-item" v-if="resultFilePopup.visible" :style="'cursor:pointer;position: relative;min-width:110px;min-height:110px;min-width:110px;max-width:110px;background-size:cover;background-image:url(\'' + resultFilePopup.img + '\')'">
                    <div v-if="resultFilePopup.ext!=''" class="div-extension-img">
                      <label>{{ resultFilePopup.ext }}</label>
                    </div>
                    <label class="labelListImage">{{ resultFilePopup.imgName }}</label>
                  </div>
                  </li> 
              </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end modal immagini share -->
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import Select2 from "@/components/Select2.vue";
import PageDetail from "@/components/PageDetail.vue";
export default {
  name: "adminCrmCategoriesPages",
  components: {
    BootstrapTable,
    Select2,
    PageDetail,
  },
  data: function () {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      language: dictionaryHelpers.getDictionary("Language"),
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      defaultLanguageOptions: [],
      DetailConfiguration: [],
      tableCategoriesPagesResult: [],
      resultFilePopupsShare: [],
      detailCategoriesPagesData: {},
      TableConfiguration: [],
      rowIdSelected: 0,
      pageImageShare: 1,
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null },
      },
      tableData: [],
      disableButton: true,
      url: window.location.pathname,
    };
  },
  created() {
    var adminCrmCategoriesPages = this;

    spinnerHelpers.show();
    adminCrmCategoriesPages.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage(),
    };

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function (result) {

      adminCrmCategoriesPages.TableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
      adminCrmCategoriesPages.DetailConfiguration = result.data.tabsConfigurations[0].pageConfigurations;

      adminCrmCategoriesPages.loadTable();
    });
  },
  methods: {
    loadTable(ln) {
      var adminCrmCategoriesPages = this;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }

      CategoriesPagesServices.getAll(ln, function (result) {
        adminCrmCategoriesPages.tableData = result.data;
        spinnerHelpers.hide();
      });
    },
    onTableCheckCustomer() {
      var countRowSelected = this.$refs.tableContents.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminCrmCategoriesPages = this;
      adminCrmCategoriesPages.loadTable(value);
      spinnerHelpers.hide();
    },
    CategoriesPagesFormatter(value, row, index, field) {
      var adminCrmCategoriesPages = this;
      var html = "";
      html +=
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html +=
        '<button class="btn btn-success" onclick="adminCrmCategoriesPages.__vue__.viewDatailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil"/></button>';
      html +=
        '<button class="btn btn-danger" onclick="adminCrmCategoriesPages.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';

      html += "</div>";
      return html;
    },


onKeyUpTitleItems() {
    var adminCrmCategories = this;
    var SeotitleToTitles= $("#seo_title").val();

   if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((93 * 10)/100) + "%";
        $('#seo_title_feedback').remove();
        $('#seo_title').before('<div id="seo_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
  }else{
   if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((93 * SeotitleToTitles.length)/30) + "%";
        $('#seo_title_feedback').remove();
        $('#seo_title').before('<div id="seo_title_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }
     if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
        var d = ((93 * SeotitleToTitles.length)/60) + "%";
        $('#seo_title_feedback').remove();
        $('#seo_title').before('<div id="seo_title_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
        var d = ((93 * SeotitleToTitles.length)/1000) + "%";
        $('#seo_title_feedback').remove();
        $('#seo_title').before('<div id="seo_title_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }
 },

    onKeyUpDescriptionItems() {
    var adminCrmCategories = this;
    var SeoDesciptionToTitles= $("#seo_description").val();

   if (SeoDesciptionToTitles == '' || SeoDesciptionToTitles == null || SeoDesciptionToTitles == 'null' || SeoDesciptionToTitles == 0) {
      var d = ((93 * 10)/100) + "%";
          $('#seo_description_feedback').remove();
          $('#seo_description').before('<div id="seo_description_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
  }else{
    if (SeoDesciptionToTitles.length >= 0 && SeoDesciptionToTitles.length <= 70){
            var d = ((93 * SeoDesciptionToTitles.length)/70) + "%";
              $('#seo_description_feedback').remove();
              $('#seo_description').before('<div id="seo_description_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 71 && SeoDesciptionToTitles.length <= 155){
            var d = ((93 * SeoDesciptionToTitles.length)/155) + "%";
            $('#seo_description_feedback').remove();
            $('#seo_description').before('<div id="seo_description_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
        }

        if (SeoDesciptionToTitles.length >= 156 && SeoDesciptionToTitles.length <= 2000){
            var d = ((93 * SeoDesciptionToTitles.length)/2000) + "%";
            $('#seo_description_feedback').remove();
            $('#seo_description').before('<div id="seo_description_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
        }
      }
  },

    changeSeoTitle(){
    var adminCrmCategoriesPages = this;
    var SeotitleToTitles= $("#seo_title").val();
    },

  changeSeoDescription(){
    var adminCrmCategoriesPages = this;
    var SeoDescriptionTitles= $("#seo_description").val();
  },

    viewDatailInfo(id) {
      spinnerHelpers.show();
      var adminCrmCategoriesPages = this;
      this.rowIdSelected = id;

      $.each(this.tableData, function (i, row) {
        if (adminCrmCategoriesPages.rowIdSelected == row.id) {
          adminCrmCategoriesPages.detailCategoriesPagesData = row;

        var SeotitleToTitles = row.seo_title;
        if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
              var d = ((93 * 10)/100) + "%";
              $('#seo_title_feedback').remove();
              $('#seo_title').before('<div id="seo_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
        }else{
        if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
              var d = ((93 * SeotitleToTitles.length)/30) + "%";
              $('#seo_title_feedback').remove();
              $('#seo_title').before('<div id="seo_title_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
            }
          if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
              var d = ((93 * SeotitleToTitles.length)/60) + "%";
              $('#seo_title_feedback').remove();
              $('#seo_title').before('<div id="seo_title_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
            }
            if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
              var d = ((93 * SeotitleToTitles.length)/1000) + "%";
              $('#seo_title_feedback').remove();
              $('#seo_title').before('<div id="seo_title_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
            }
          } 
          
      var SeoDesciptionToTitles = row.seo_description;

      if (SeoDesciptionToTitles == '' || SeoDesciptionToTitles == null || SeoDesciptionToTitles == 'null' || SeoDesciptionToTitles == 0) {
            var d = ((93 * 10)/100) + "%";
                $('#seo_description_feedback').remove();
                $('#seo_description').before('<div id="seo_description_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
        }else{
          if (SeoDesciptionToTitles.length >= 0 && SeoDesciptionToTitles.length <= 70){
                  var d = ((93 * SeoDesciptionToTitles.length)/70) + "%";
                    $('#seo_description_feedback').remove();
                    $('#seo_description').before('<div id="seo_description_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
              }

              if (SeoDesciptionToTitles.length >= 71 && SeoDesciptionToTitles.length <= 155){
                  var d = ((93 * SeoDesciptionToTitles.length)/155) + "%";
                  $('#seo_description_feedback').remove();
                  $('#seo_description').before('<div id="seo_description_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
              }

              if (SeoDesciptionToTitles.length >= 156 && SeoDesciptionToTitles.length <= 2000){
                  var d = ((93 * SeoDesciptionToTitles.length)/2000) + "%";
                  $('#seo_description_feedback').remove();
                  $('#seo_description').before('<div id="seo_description_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
              }
            }
        }
      });

      $("#tabTable").removeClass("active");
      $("#tabNationDetail").addClass("active");
      spinnerHelpers.hide();
    },


    delete(id) {
      if (confirm("Sei sicuro di voler eliminare?")) {
        this.executedelete(id);
      }
    },
    executedelete(id) {
      var adminCrmCategoriesPages = this;
      spinnerHelpers.show();
      CategoriesPagesServices.del(id, function () {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
        var ln =
          adminCrmCategoriesPages.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmCategoriesPages.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },
    onClickNew() {
      spinnerHelpers.show();
      this.rowIdSelected = 0;
      this.detailCategoriesPagesData = {};

      $('#seo_title_feedback').remove();
      $('#seo_description_feedback').remove();

      if ($('#seo_title').val() == ''){
            $('#seo_title').before('<div id="seo_title_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if ($('#seo_description').val() == ''){
            $('#seo_description').before('<div id="seo_description_feedback" style="width: calc(9.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }

      $("#tabTable").removeClass("active");
      $("#tabNationDetail").addClass("active");
      spinnerHelpers.hide();
    },
    cancelNewCategoriesPages() {
      spinnerHelpers.show();
      this.detailCategoriesPagesData = {};
      $("#tabTable").addClass("active");
      $("#tabNationDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    saveNewCategoriesPages() {
      spinnerHelpers.show();
      var adminCrmCategoriesPages = this;
      this.detailCategoriesPagesData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailCategoriesPagesData.id = this.rowIdSelected;

        CategoriesPagesServices.update(this.detailCategoriesPagesData, function (result) {
          notificationHelpers.success(adminCrmCategoriesPages.updateCompleted);
          adminCrmCategoriesPages.loadTable();
          $("#tabTable").addClass("active");
          $("#tabNationDetail").removeClass("active");
        });
      } else {
        CategoriesPagesServices.insert(this.detailCategoriesPagesData, function (result) {
          notificationHelpers.success(adminCrmCategoriesPages.insertCompleted);
          adminCrmCategoriesPages.loadTable();
          $("#tabTable").addClass("active");
          $("#tabNationDetail").removeClass("active");
        });
      }
    },
    handleScrollShare(){
      if($('#ul-image-share').scrollTop() + $('#ul-image-share').innerHeight() >= $('#ul-image-share')[0].scrollHeight) {
        this.getImageShare(this.pageImageShare + 1);
        this.pageImageShare = this.pageImageShare + 1;
      }
    },
    SearchShare() { 
      var adminSettingNews = this;
      adminSettingNews.getImageShare(1);
    },
    getImageShare(page) {
      $("#modalImgBlogFormShare").modal("show"); 
      var adminSettingNews = this; 
      var data = {
        page : page,
        search : $('#modalImgBlogFormShare #searchShare').val(),
        month : $('#modalImgBlogFormShare #monthShare').val(),
        year : $('#modalImgBlogFormShare #yearShare').val(),
      };

      pageServices.getByFile(data, function (result) {
        if(adminSettingNews.resultFilePopupsShare.length == 0 || page == 1){
          adminSettingNews.resultFilePopupsShare = result.data;
          $('#ul-image-share').css('max-height', window.innerHeight - 200);
        }else{
          var array1 = adminSettingNews.resultFilePopupsShare;
          var array2 = result.data;
          var newArray = array1.concat(array2);
          adminSettingNews.resultFilePopupsShare = newArray;
        }
      }); 
    },
    handleFileInputShare(e) {
      
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (var i = 0; i < files.length; i++) {
        this.createImgAggShare(e.target.id, files[i].name, files[i]);
      }
    },
    createImgAggShare(id, name, file) {
      var adminSettingNews = this;
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        var jsonImgUpload = {};
        jsonImgUpload["id"] = adminSettingNews.cont + 1;
        adminSettingNews.cont = adminSettingNews.cont + 1;
        jsonImgUpload["name"] = name;
        jsonImgUpload["size"] = "0";
        jsonImgUpload["base64"] = e.target.result;
        adminSettingNews.detailCategoriesPagesData.url_cover_image = name;
        adminSettingNews.detailCategoriesPagesData.base64CoverImage =  e.target.result;
        console.log(adminSettingNews.detailCategoriesPagesData.url_cover_image);   
        console.log(adminSettingNews.detailCategoriesPagesData.base64CoverImage);  
        adminSettingNews.files.push(jsonImgUpload);
      
      };
      reader.readAsDataURL(file);
    },


    selectImgShare(img,imgName) {
      var adminSettingNews = this; 
      $("#modalImgBlogFormShare").modal("hide");
      adminSettingNews.detailCategoriesPagesData.url_cover_image = img;
      adminSettingNews.detailCategoriesPagesData.base64CoverImage ='';
    },


   /* convertToWebP() {
      var adminSettingNews = this; 
      console.log(adminSettingNews.detailCategoriesPagesData);

    var data = {
        url_cover_image : adminSettingNews.detailCategoriesPagesData.url_cover_image,
        base64CoverImage : adminSettingNews.detailCategoriesPagesData.base64CoverImage,
      };

      CategoriesPagesServices.convertToWebP(data, function (result) {
        console.log(result);
          //adminSettingNews.resultFilePopupsShare = result.data;
      }); 
    },*/
  },
};
</script>
<style scoped>
.card-title-admin .card {
  background: transparent;
  border: 0px;
}
.card-title-admin h1 {
  font-size: 40px;
  font-weight: lighter;
  color: #303c54;
}

.align-btns {
    position: absolute;
    z-index: 1;
    margin-top: 10px;
}
.span {
  position: absolute;
  margin-top: 75px;
}



.list-group-item{
  margin-bottom: 5px;
  height: 105px;
  padding: 0px;
  background: #ededed;
  border-radius: 0px;
}

#ul-image{
  width: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  max-height: 50px;
  overflow:auto;
}
#ul-image-share{
  width: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  max-height: 50px;
  overflow:auto;
}
.listLi {
  list-style: none;
  text-align: center;
}
.labelListImage {
  cursor: pointer;
  font-size: 12px;
  padding: 2px;
  position: absolute;
  left: 0;
  top: 0px !important;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  background: rgba(255,255,255,0.7);
}
.modal-dialo{
  /*margin-left: calc(1vw);*/
  padding: 7px;
  width: calc(98vw);
  height: calc(99vh);
}

.popup{
height:100%;
}


.div-extension-img{
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: #238AE6;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
    box-shadow: 0px 0px 7px -2px rgb(0 0 0 / 30%);
}

.div-extension-img label {
    font-size: 10px;
    margin: 0px !important;
    display: block;
    color: #fff;
    font-weight: bold;
}

.custom-file-upload {
  padding: 20px;
  cursor: pointer;
  text-align: center;
  font-weight: lighter;
  border: 3px dashed #ededed;
  border-radius: 10px;
  color: slategrey;
}

#imgAggUpload[type="file"] {
  display: none;
}
</style>
